<template>
  <div class="collapse_item__wrappers mb-2">
    <div class="collapse_item__header mb-1">
      <div class="collapse_item__header_icon">
        <span @click="toggle">
          <div v-if="!closed()" class="icon_class">
            <i class="el-icon-arrow-down" style="font-weight: 800" />
          </div>
          <div v-else class="icon_class">
            <i class="el-icon-arrow-right" style="font-weight: 800" />
          </div>
        </span>
      </div>
      <div class="collapse_item__header_text" @click="toggle">
        <slot name="title">
          <span>{{ title }}</span>
        </slot>
      </div>
      <div
        class="collapse_item__header_icon"
        style="font-size: 13px"
        v-if="isCreateChild"
      >
        <div
          class="icon_class"
          style="height: 17px; width: 17px; line-height: 17px"
          @click="$emit('addChild')"
        >
          <i class="el-icon-plus" />
        </div>
      </div>
    </div>
    <div class="collapse_item__body">
      <el-collapse-transition>
        <div v-show="!closed()">
          <slot />
        </div>
      </el-collapse-transition>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    title: { type: String, default: '' },
    isSuper: { type: Boolean, default: false },
    taskInfo: { type: Object, default: () => {} },
  },
  inject: ['open', 'close', 'toggle', 'closed'],
  computed: {
    ...mapState('admin/user', ['info']),
    isCreateChild() {
      const { userCode } = this.info
      const { createBy, tskBy, tskStatus } = this.taskInfo
      return (
        (createBy === userCode || tskBy === userCode || this.isSuper) &&
        ['A', 'N', 'P'].includes(tskStatus)
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.collapse_item__wrappers {
  .collapse_item__header {
    display: flex;
    align-items: center;
    .collapse_item__header_icon {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      margin-right: 6px;
      .icon_class {
        background-color: rgba(9, 30, 66, 0.08);
        height: 15px;
        width: 15px;
        line-height: 15px;
        border-radius: 5px;
        text-align: center;
        color: #344563;
      }
    }
    .collapse_item__header_text {
      flex: 1;
      line-height: 20px;
      font-size: 14px;
      font-weight: 600;
    }
  }
  .collapse_item__body {
    margin-left: 21px;
  }
}
.icon_class:hover {
  background-color: rgba(9, 30, 66, 0.13) !important;
}
</style>
